import { sva } from '@onbeam/business-styled-system/css';

export const accordion = sva({
  className: 'accordion',
  slots: ['trigger', 'triggerContent', 'chevron', 'content'],
  base: {
    trigger: {
      w: 'full',
      display: 'flex',
      justifyContent: 'space-between',
      px: '4',
      py: '2.5',
      alignItems: 'center',
      rounded: 'xs',
      transition: 'colors',
      cursor: 'pointer',
      _hoverFocus: {
        bg: 'mono.quartenery',
      },
      _open: {
        '& > svg': {
          transform: 'rotate(180deg)',
        },
      },
    },
    triggerContent: {
      display: 'flex',
      gap: '2',
      alignItems: 'center',
    },
    chevron: {
      transition: 'transform',
      transform: 'rotate(0deg)',
    },
    content: {
      overflow: 'hidden',
      animationDuration: 'normal',
      animationTimingFunction: 'out',

      _open: {
        animationName: 'radixContentSlideDown',
      },
      _closed: {
        animationName: 'radixContentSlideUp',
      },
    },
  },
});
